import { intramurosBase } from '@/utils/intramuros'

import type { QuestionnaireCareplanActivity } from '../types/questionnaire.types'

/**
 * Get the URL to the questionnaire for a careplan activity
 * @param activity - The activity to get the questionnaire URL for
 * @param awellHostedPagesEnabled - Whether to use Awell hosted pages
 * @returns
 */
export function buildCareplanActivityQuestionnaireUrl(
  activity: QuestionnaireCareplanActivity,
  awellHostedPagesEnabled?: boolean,
) {
  const questionnaireIdOrSlug = activity?.questionnaireId || activity?.meta?.questionnaireSlug

  if (!questionnaireIdOrSlug) {
    console.error('No questionnaire ID or slug found')
    return
  }

  const shouldUseAwellHostedPages =
    awellHostedPagesEnabled &&
    // @ts-expect-error - TODO: fix this type
    activity?.questionnaire?.driver === 'awell'

  const search = new URLSearchParams({
    view: shouldUseAwellHostedPages ? 'awell' : 'default',
  })

  const activityId = activity?.id

  if (activityId) {
    if (intramurosBase && activity) {
      return `${intramurosBase}/questionnaire/${activityId}?${search}`
    }
    return `/questionnaire/${activityId}?${search}`
  }
}
